import { cloneDeep } from 'lodash';
import * as TYPES from './types';

const initialState = {
  fetching: false,
  errorMessages: null,
  errorMessagesProfile: null,
  isCreated: false,
  createdScannedDocument: {},
  total: 0,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case TYPES.GET_SCANNED_DOCUMENT_REQUEST:
    case TYPES.CREATE_SCANNED_DOCUMENT_REQUEST:
      return { ...state, fetching: true, errorFetching: false };

    case TYPES.UPDATE_SCANNED_DOCUMENT_REQUEST:
    case TYPES.DELETE_SCANNED_DOCUMENT_REQUEST:
      return { ...state, fetching: true };

    case TYPES.GET_SCANNED_DOCUMENT_ERROR:
    case TYPES.CREATE_SCANNED_DOCUMENT_ERROR:
    case TYPES.DELETE_SCANNED_DOCUMENT_ERROR:
    case TYPES.UPDATE_SCANNED_DOCUMENT_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
        isCreated: false,
      };
    case TYPES.CREATE_ERRORS:
      return {
        ...state,
        errorMessages: payload,
        isCreated: false,
        fetching: false,
      };
    case TYPES.CREATE_SCANNED_DOCUMENT_SUCCESS:
      return {
        ...state,
        fetching: false,
        total: state.total + 1,
        isCreated: true,
        createdScannedDocument: payload,
      };

    case TYPES.DELETE_SCANNED_DOCUMENT_SUCCESS: {
      const list = cloneDeep(state.list);
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list.splice(index, 1);
      else list.push(index);
      return {
        ...state,
        fetching: false,
        total: state.total - 1,
      };
    }

    case TYPES.CLEAR_SCANNED_DOCUMENTS_STATE: {
      return {
        ...state,
        fetching: false,
        errorMessages: null,
        errorMessagesProfile: null,
        isCreated: false,
        createdScannedDocument: {},
      };
    }

    case TYPES.CLEAR_ERRORS: {
      return { ...state, errorMessages: null };
    }

    case TYPES.INIT_REDUCER:
      return {
        ...initialState,
        errorMessages: null,
        errorMessagesProfile: null,
      };

    default:
      return { ...state };
  }
}
